Wee.fn.make('home', {
	init: function() {
		$('ref:emailSignup').csrf();

		this.$private.initEvents();

		Wee.carousel.init({
			elementRef: 'thumb',
			arrows: 'arrow'
		});
	},
	unload: function() {
		Wee.carousel.unload();

		$.events.off(false, '.home');
	}
}, {
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:emailField': {
				click: function(e) {
					scope.activateInput();

					e.stopPropagation();
				}
			},
			'ref:emailInput': {
				keydown: function() {
					scope.clearFormErrors();
				}
			},
			'ref:emailSignup': {
				submit: function(e) {
					scope.clearFormErrors();
					scope.submitForm();

					e.preventDefault();
				}
			},
			'document': {
				click: function() {
					scope.deactivateInput();
					scope.clearFormErrors();
				}
			}
		}, {
			namespace: 'home'
		});
	},
	submitForm: function() {
		var scope = this;

		clearTimeout(scope.timer);

		$.fetch.request({
			url: $.routes.uri().path,
			method: 'post',
			json: true,
			data: $('ref:emailSignup').serialize(),
			success: function(response) {
				if (response.success) {
					$('ref:emailSignupButton').addClass('-success');

					scope.timer = setTimeout(function() {
						scope.deactivateInput();
					}, 1000);
				} else {
					scope.insertFormError(response.message);
				}
			},
			error: function() {
				scope.insertFormError('Something went wrong, please try again.');
			}
		});
	},
	activateInput: function() {
		$('ref:emailField').activate()
			.addClass('-is-focused');

		$('ref:emailInput')[0].focus();

		$('ref:emailInput').attr('placeholder', 'Enter Email');
	},
	deactivateInput: function() {
		var $emailInput = $('ref:emailInput');

		$('ref:emailSignupButton').removeClass('-success');

		$('ref:emailField').deactivate()
			.removeClass('-is-focused');

		$emailInput.val('');

		$emailInput.attr('placeholder', '');

		$emailInput[0].blur();
	},
	insertFormError: function(message) {
		$('ref:emailSignup').after('<span class="form-error -email-error" data-ref="formError">' + message + '</span>');
		$('ref:formField').addClass('-error');
	},
	clearFormErrors: function() {
		$('ref:formField').removeClass('-error');
		$('ref:formError').remove();
	}
});